import { mapActions, mapGetters } from 'vuex'

import { get } from 'lodash'

import { CSendingTypesGenerallyAvailable } from '@sigmasms/commons'

import messages from '@/messages'
import { checkPermissions, getTranslate, isStringNotEmpty } from '@/utils'

export default {
  computed: {
    ...mapGetters({
      platform: 'global/platform',
      browser: 'global/browser',
      locale: 'locale/locale',
      viewport: 'viewport/viewport',
      account: 'account/account',
      sendingTypes: 'account/sendingTypes',
      isPlatinum: 'account/isPlatinum',
      globalSettings: 'settings/global'
    }),

    $_dialogMaxWidth() {
      switch (true) {
        case this.viewport.size.width >= 1800: return 1400
        case this.viewport.size.width >= 1200: return 1000
        case this.viewport.size.width >= 960: return 600
        default: return undefined
      }
    }
  },

  methods: {
    ...mapActions({ addSnackbar: 'notifications/addSnackbar' }),

    checkPermissions(params, logic = null, accept = null, permissions = null) {
      return checkPermissions(params, logic, accept, permissions || this.account.permissions)
    },

    getTranslate(path, options = {}) {
      return getTranslate(path, options)
    },

    getTranslateTemplate(path, options = {}) {
      if (isStringNotEmpty(path)) {
        let template = get(messages, [ this.locale || options.locale || 'en', path ].join('.'))
        if (template) {
          template = template.split('|')
          switch (options.count) {
            case undefined:
              console.warn('[getTranslateTemplate] Options count must be a number for translate by template')
              break
            case 0:
              return template[0]
            case 1:
              return template[1]
            default:
              return template[2].replace('{count}', options.count)
          }
        } else {
          console.warn(`[getTranslateTemplate] No translation template found for this path - ${path}`)

          return path
        }
      }
    },

    getSendingTypesByPermission(permission) {
      if (permission) {
        if (this.checkPermissions(permission)) {
          return CSendingTypesGenerallyAvailable
        }
      }

      return this.sendingTypes || []
    }
  }
}
